// This is a mock authentication service
const login = async (username, password) => {
    if (username === 'admin' && password === 'Test310_567') {
      const token = 'fake-jwt-token';
      localStorage.setItem('user', JSON.stringify({ username, token }));
      return { username, token };
    } else {
      throw new Error('Username or password is incorrect');
    }
  };
  
  const logout = () => {
    localStorage.removeItem('user');
  };
  
  export const AuthService = {
    login,
    logout,
  };
  